<template>
<div class="fuel-utilization__filters">
  <div class="fuel-utilization__filter fuel-utilization__filter--work-orders">
    <div class="filter__form">
      <FilterWorkOrderDetails></FilterWorkOrderDetails>
    </div>
  </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FilterWorkOrderDetails from './FilterWorkOrderDetails.vue';

  //////////////////////////////////////
  // Global Components
  //////////////////////////////////////

  export default {
    name: 'Filters',
    components: {
      FilterWorkOrderDetails,
    },
    computed: {
      ...mapGetters('fuelUtilization', ['filtersShown']),
      showFilters() {
        this.filtersShown.indexOf('workOrderParams') > -1;
      }
    },
  };
</script>
